<template>
  <div class="cont">
    <div style="width: 100%; display: flex; align-items: center;">
      <h2 class="page-title">Your Playlists</h2>
    </div>

    <div class="create-row">
      <input type="text" placeholder="New playlist name" v-model="newName" @keyup.enter="create" />
      <button @click="create" :disabled="!newName.trim()">Create</button>
    </div>

    <transition name="fade" mode="out-in">
      <div v-if="playlistsStore.loading" class="state-message">
        <div class="loader"></div>
      </div>
      <div v-else-if="!playlistsStore.playlists.length" class="state-message">
        <v-icon size="48" color="#555">mdi-playlist-music-outline</v-icon>
        <p>Create your first playlist above.</p>
      </div>
      <div v-else class="list">
        <div
          class="listItem"
          v-for="playlist in playlistsStore.playlists"
          :key="playlist.id"
          @click="$router.push(`/playlists/${playlist.id}`)"
        >
          <v-icon color="#fff" size="36">mdi-playlist-music</v-icon>
          <div class="info">
            <p class="track-title">{{ playlist.name }}</p>
            <p class="song-count">{{ playlist.song_count }} songs</p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { usePlaylistsStore } from '../stores/playlists';

export default {
  name: 'PlaylistsListComponent',
  setup() {
    const playlistsStore = usePlaylistsStore();
    return { playlistsStore };
  },
  data() {
    return { newName: '' };
  },
  mounted() {
    this.playlistsStore.ensureLoaded();
  },
  methods: {
    goBack() {
      if (window.history.state && window.history.state.back) {
        this.$router.back();
      } else {
        this.$router.push({ name: 'home' });
      }
    },
    async create() {
      const name = this.newName.trim();
      if (!name) return;
      const playlist = await this.playlistsStore.createPlaylist(name);
      this.newName = '';
      if (playlist) {
        this.$router.push(`/playlists/${playlist.id}`);
      }
    },
  },
};
</script>

<style scoped>
.cont {
  width: 100%;
  height: 100%;
  color: white;
  padding: 0 4%;
  box-sizing: border-box;
  overflow-y: auto;
  scrollbar-width: none;
}

.page-title {
  margin-left: 12px;
  font-weight: 600;
  font-size: 1.4rem;
}

.create-row {
  display: flex;
  gap: 8px;
  margin: 2% 0;
}

.create-row input {
  flex: 1;
  max-width: 320px;
  padding: 10px;
  border: none;
  border-radius: 4px;
  background: #333;
  color: white;
}

.create-row input:focus {
  outline: 2px solid #e50914;
}

.create-row button {
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  background: #e50914;
  color: white;
  font-weight: 600;
  cursor: pointer;
}

.create-row button:disabled {
  background: #7a0a0f;
  cursor: not-allowed;
}

.state-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50%;
  color: #888;
  gap: 12px;
}

.list {
  margin-top: 2%;
  padding-bottom: 3%;
}

.listItem {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  cursor: pointer;
  padding: 10px 6px;
  border-radius: 8px;
  transition: background 0.2s;
}

.listItem:hover {
  background: #ffffff0d;
}

.track-title {
  text-align: left;
}

.song-count {
  color: grey;
  font-size: small;
  text-align: left;
}

@media (max-width: 675px) {
  .cont {
    padding: 0 2%;
  }
  .create-row input {
    max-width: none;
  }
}
</style>
